import React, { Component, Fragment } from 'react'
import { Radio, Button, Spin } from 'hljd'
import style from '../style.module.less'
import { observer } from 'mobx-react'
const RadioGroup = Radio.Group
const RadioButton = Radio.Button

@observer
export default class extends Component {
  render() {
    const {
      changeType,
      activeTab,
      submit,
      livePrice,
      field,
      changeField,
      checkedField
    } = this.props.store
    const marketingAdv = `（${(checkedField.marketing_adv || '')
      .replace(/{/, '<i>')
      .replace(/}/, '</i>')}）`
    return (
      <Fragment>
        {livePrice.length > 0 ? (
          <div className={style.form}>
            <div className={style.form_item}>
              <label className={style.form_item__label}>覆盖范围：</label>
              <RadioGroup
                value={activeTab}
                buttonStyle="solid"
                onChange={changeType}
              >
                <RadioButton value="country">全国</RadioButton>
                <RadioButton value="local">本地及周边</RadioButton>
              </RadioGroup>
            </div>
            <div className={style.form_item}>
              <label className={style.form_item__label}>购买套餐：</label>
              <RadioGroup
                value={field}
                style={{ verticalAlign: 'text-top' }}
                onChange={changeField}
              >
                {livePrice.map((item, key) => (
                  <RadioButton value={item.live_count} key={key}>
                    <div className={style.card}>
                      {item.card_adv && (
                        <div className="discount_txt">{item.card_adv}</div>
                      )}
                      <div className={style.real_price}>
                        <span className={style.real_price_num}>
                          <i className={style.real_price_unit}>￥</i>
                          {item.show_price}
                        </span>
                        <span className={style.real_price_field}>
                          {item.live_count}场
                        </span>
                      </div>
                      <div className={style.original_price}>
                        ￥{item.mark_price}
                      </div>
                    </div>
                  </RadioButton>
                ))}
              </RadioGroup>
            </div>
            <div className={style.form_item}>
              <label className={style.form_item__label}>订单金额：</label>
              <div className={style.form_item__content}>
                <span className={style.orderPrice}>
                  {checkedField.show_price}
                </span>元
                {checkedField.marketing_adv && (
                  <span
                    className={style.marketing_adv}
                    dangerouslySetInnerHTML={{
                      __html: marketingAdv
                    }}
                  />
                )}
              </div>
            </div>
            <Button
              type="primary"
              style={{
                width: 120,
                height: 36,
                marginLeft: 99
              }}
              onClick={submit}
            >
              提交
            </Button>
          </div>
        ) : (
          <div style={{ textAlign: 'center', margin: '30%' }}>
            <Spin size="large" />
          </div>
        )}
      </Fragment>
    )
  }
}
